import { zodResolver } from "@hookform/resolvers/zod"
import { ValidationMessage } from "@sop/SEEMP/SeempActionCard"
import { Button } from "@ui-lib/index"
import { requestApi2 } from "@utils/http"
import { endpoints, OpModeSchemaWithModes } from "api"
import { Dispatch, SetStateAction, useState } from "react"
import { useForm } from "react-hook-form"
import { MultiValue } from "react-select"
import { z } from "zod"
import ActionGroupCard from "./ActionGroupCard"
import { NewGroupForm, SeempSchemaConfigFE } from "./types"

export default function SeempSchemaAccordion({
	schema,
	opModeSchemasWithModes,
	setSeempSchemas,
}: {
	schema: SeempSchemaConfigFE
	opModeSchemasWithModes: OpModeSchemaWithModes[]
	setSeempSchemas: Dispatch<SetStateAction<SeempSchemaConfigFE[]>>
}) {
	const {
		register,
		handleSubmit,
		formState: { isDirty, errors },
		control,
		reset,
		setValue,
		watch,
		trigger,
	} = useForm<z.infer<typeof NewGroupForm>>({
		resolver: zodResolver(NewGroupForm),
		defaultValues: {
			label: "",
			description: "",
			opModeIds: [],
		},
		mode: "onChange",
	})

	const label = watch("label")
	const description = watch("description")
	const opModeIds = watch("opModeIds")

	const handleDeleteSchema = async (id: number) => {
		if (!window.confirm("Are you sure you want to delete this schema?")) {
			return
		}
		try {
			await requestApi2(endpoints.seempDeleteSchema, { id })
			alert("Schema deleted successfully")
			setSeempSchemas((prev) => prev.filter((schema) => schema.id !== id))
		} catch (error) {
			console.error("Error deleting schema:", error)
			alert("Error deleting schema")
		}
	}

	const handleCreateActionGroup = async (schemaId: number) => {
		await trigger()
		if (label === "" || description === "") {
			alert("Please fill in all fields")
			return
		}
		const newGroup = await requestApi2(endpoints.seempAddActionGroup, {
			label,
			description,
			//opModeIds,
			//seempSchemaId: schemaId,
		})
		if (newGroup !== null) {
			setSeempSchemas((prev) =>
				prev.map((schema) =>
					schema.id === schemaId
						? { ...schema, actionGroups: [...schema.actionGroups, newGroup] }
						: schema
				)
			)
			alert("Group added successfully")
			reset()
		} else {
			alert("Error adding group")
		}
	}
	// const opModeOptions = opModeSchemasWithModes
	// 	.find((s) => s.schemaId === schema.opModeSchemaId)
	// 	?.opModes.sort((a, b) => a.name.localeCompare(b.name))
	// 	.map((opMode) => ({
	// 		value: opMode.id,
	// 		label: `${opMode.name} (${opMode.id})`,
	// 	}))

	const vesselOptions = schema.allowedPlants
		.sort((a, b) => a.name.localeCompare(b.name))
		.map((plant) => ({
			value: plant.id,
			label: `${plant.name} (${plant.id})`,
		}))
	const [selectedVessels, setSelectedVessels] = useState<
		MultiValue<{ value: number; label: string }>
	>(
		schema.plants
			.sort((a, b) => a.name.localeCompare(b.name))
			.map((plant) => ({
				value: plant.id,
				label: `${plant.name} (${plant.id})`,
			}))
	)

	const handleUpdateSchema = async (schemaId: number) => {
		try {
			await requestApi2(endpoints.seempUpdateSchema, {
				id: schemaId,
				plants: selectedVessels.map((v) => ({ id: v.value, name: v.label })),
			})
			alert("Schema updated successfully")
		} catch (error) {
			console.error("Error updating schema:", error)
			alert("Error updating schema")
		}
	}

	return (
		// <Accordion.Item
		// 	className={`border-dipai-secondary-901/20 border-1 not-last:border-b-0 first:border-t-0`}
		// 	value={`${schema.id}`}
		// >
		// 	<Accordion.Header className="group grid min-h-10 grid-cols-[43rem_1fr_3rem_3rem]">
		// 		<Accordion.Trigger
		// 			className={
		// 				"group-hover:bg-dipai-secondary-800/5 data-[state=open]:bg-dipai-secondary-800/5 grid w-full grid-cols-[3rem_5rem_15rem_20rem_1fr] items-center divide-x border-r-1 outline-none"
		// 			}
		// 		>
		// 			<div className={`flex h-full items-center justify-center`}>
		// 				<MdChevronLeft
		// 					className="text-dipai-secondary-901 group-hover:text-dipai-secondary-600 size-8 rotate-180 transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-hover:scale-110 group-hover:cursor-pointer group-data-[state=open]:rotate-270"
		// 					aria-hidden
		// 				/>
		// 			</div>
		// 			<p
		// 				className={`text-body flex h-full min-h-10 items-center justify-center leading-[1.125rem]`}
		// 			>
		// 				{schema.id}
		// 			</p>
		// 			<p
		// 				className={`text-body flex h-full min-h-10 items-center justify-center px-4 leading-[1.125rem]`}
		// 			>{`${schema.label}`}</p>
		// 			{/* <p
		// 				className={`text-body flex h-full min-h-10 items-center justify-center px-4 leading-[1.125rem]`}
		// 			>
		// 				{schema.opModeSchemaId}
		// 			</p> */}
		// 		</Accordion.Trigger>
		// 		{/* <div
		// 			className={`group-hover:bg-dipai-secondary-800/5 group-data-[state=open]:bg-dipai-secondary-800/5 flex items-center border-r-1 px-2 py-2`}
		// 		>
		// 			<ReactSelect
		// 				className="w-full"
		// 				options={vesselOptions}
		// 				placeholder={"select vessels..."}
		// 				styles={selectComponentStyles(errors.opModeIds?.message, false)}
		// 				isMulti={true}
		// 				value={selectedVessels}
		// 				onChange={(v) => setSelectedVessels(v)}
		// 				// isDisabled={areFieldsDisabled}
		// 				isSearchable={true}
		// 				hideSelectedOptions={false}
		// 				closeMenuOnSelect={false}
		// 				isClearable={true}
		// 				menuPlacement="auto"
		// 				menuPortalTarget={document.body}
		// 			/>
		// 		</div> */}
		// 		{/* <div
		// 			className={`group-hover:bg-dipai-secondary-800/5 group-data-[state=open]:bg-dipai-secondary-800/5 flex items-center justify-center`}
		// 		>
		// 			<IconButton
		// 				variant={"text-dark"}
		// 				onClick={() => handleDeleteSchema(schema.id)}
		// 			>
		// 				<IconButton.Icon>{MdDelete}</IconButton.Icon>
		// 			</IconButton>
		// 		</div> */}
		// 		{/* <div
		// 			className={`group-hover:bg-dipai-secondary-800/5 group-data-[state=open]:bg-dipai-secondary-800/5 flex items-center justify-center`}
		// 		>
		// 			<IconButton
		// 				variant={"text-dark"}
		// 				onClick={() => handleUpdateSchema(schema.id)}
		// 			>
		// 				<IconButton.Icon>{MdSave}</IconButton.Icon>
		// 			</IconButton>
		// 		</div> */}
		// 	</Accordion.Header>
		<div className={"grid w-full grid-cols-[1fr] gap-4 overflow-hidden p-4 pl-12"}>
			{/* NEW GROUP SECTION */}
			<div className={`border-dipai-secondary-901/50 flex flex-col gap-2 border-1 px-4 py-2`}>
				<div className={`flex items-center justify-between border-b-1 pb-2`}>
					<p className={`text-dipai-secondary-901 text-menu font-semibold`}>
						Add action group
					</p>
					<Button
						variant={"filled-primary"}
						disabled={
							!(
								isDirty &&
								Object.keys(errors).length === 0 &&
								label !== "" &&
								description !== ""
							)
						}
						onClick={() => handleCreateActionGroup(schema.id)}
					>
						<Button.Label>+ op mode group</Button.Label>
					</Button>
				</div>
				<div className={`grid grid-cols-[1fr_2fr] gap-4`}>
					<div className={`flex flex-col gap-1.5`}>
						<label
							className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
							htmlFor={`new_group_label_schema_${schema.id}`}
						>
							name
						</label>
						<input
							className={`h-8 w-full rounded-sm border-1 px-2 outline-none focus:ring-1 ${errors.label !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500"}`}
							id={`new_group_label_schema_${schema.id}`}
							{...register("label")}
							placeholder={"enter a name for the group..."}
						/>
						{errors.label?.message !== undefined ? (
							<ValidationMessage
								type={"error"}
								validationMessage={errors.label.message}
							/>
						) : null}
					</div>
					<div className={`flex flex-col gap-1.5`}>
						<label
							className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
							htmlFor={`new_group_description_schema_${schema.id}`}
						>
							description
						</label>
						<input
							className={`h-8 w-full rounded-sm border-1 px-2 outline-none focus:ring-1 ${errors.description !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500"}`}
							id={`new_group_description_schema_${schema.id}`}
							{...register("description")}
							placeholder={"enter a description for the group..."}
						/>
						{errors.description?.message !== undefined ? (
							<ValidationMessage
								type={"error"}
								validationMessage={errors.description.message}
							/>
						) : null}
					</div>
				</div>

				{/* <div className={`flex flex-col gap-1.5`}>
						<label
							className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
							htmlFor={`new_group_op_modes_schema_${schema.id}`}
						>
							op modes
						</label>
						<Controller
							name="opModeIds"
							control={control}
							rules={{
								required: "Please select at least an operation mode",
							}}
							render={({ field, fieldState }) => {
								const selected = opModeOptions?.filter((o) =>
									field.value?.includes(o.value)
								)
								return (
									<ReactSelect
										{...field}
										id={`new_group_op_modes_schema_${schema.id}`}
										className="min-w-100"
										options={opModeOptions}
										placeholder={"select the op modes..."}
										styles={selectComponentStyles(
											errors.opModeIds?.message,
											false
										)}
										isMulti={true}
										value={selected}
										onChange={(
											mv: MultiValue<{ value: number; label: string }>
										) => field.onChange(mv.map((o) => o.value))}
										// isDisabled={areFieldsDisabled}
										isSearchable={true}
										hideSelectedOptions={false}
										closeMenuOnSelect={false}
										isClearable={true}
										menuPlacement="auto"
										menuPortalTarget={document.body}
									/>
								)
							}}
						/>
						{errors.opModeIds?.message !== undefined ? (
							<ValidationMessage
								type={"error"}
								validationMessage={errors.opModeIds.message}
							/>
						) : null}
					</div> */}
			</div>
			{/* GROUPS SECTION */}
			{schema.actionGroups.map((group) => (
				<ActionGroupCard
					key={group.id}
					schemaId={schema.id}
					//opModeSchemaId={schema.opModeSchemaId}
					opModeSchemasWithModes={opModeSchemasWithModes}
					actionGroup={group}
					setSeempSchemas={setSeempSchemas}
				/>
			))}

			{/* </Accordion.Content>
		</Accordion.Item> */}
		</div>
	)
}
